import type { Team } from "@repo/types";
import {
  Sheet,
  SheetContent,
  SheetBody,
  SheetHeader,
  SheetTitle,
} from "@repo/ui/components/Base/Sheet";
import { TeamForm } from "./TeamForm";
interface EditTeamSheetProps {
  open: boolean;
  setOpen: (arg1: boolean) => void;
  team: Team;
  tenantId: string;
}
export const EditTeamSheet = ({
  open,
  setOpen,
  team,
  tenantId,
}: EditTeamSheetProps) => {
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="overflow-y-scroll">
        <SheetHeader>
          {team && (
            <div>
              <SheetTitle>{`Edit Team`}</SheetTitle>
              <SheetBody>
                <TeamForm
                  teamFormData={team}
                  tenantId={tenantId}
                  handleCancel={() => setOpen(false)}
                  handleComplete={() => setOpen(false)}
                />
              </SheetBody>
            </div>
          )}
        </SheetHeader>
      </SheetContent>
    </Sheet>
  );
};
